"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColoredIcon = void 0;

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("./shared/styles");

var ColoredIcon = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Icon, process.env.NODE_ENV === "production" ? {
  target: "e10dsljn0"
} : {
  target: "e10dsljn0",
  label: "ColoredIcon"
})("color:", function (props) {
  return _styles.color[props.color];
}, ";");
exports.ColoredIcon = ColoredIcon;